import { Component, Directive, ElementRef, HostListener } from '@angular/core';
import { FocusManagerService } from '../focus-manager.service';


@Component({
  selector: 'base-element',
  template: '<ng-content></ng-content>',
  styles: ''
})
export  class BaseElementComponent {

  constructor(public elementRef: ElementRef<HTMLElement>, public focusManager: FocusManagerService) { }

  public showFocus = false;
  public isEditing = false;

  public keyProperty = "base-base"

  onkeydow = (e:Event) => {
      let keyEv = e as KeyboardEvent;
      if (keyEv.key == "Escape") {
        this.close();
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return;
      }
    };

  open() {
    this.isEditing = true;
    this.focusManager.pushFocus(this.keyProperty);
    this.elementRef.nativeElement.addEventListener("keydown", this.onkeydow, true);
  }

  close() {

    this.isEditing = false;
    this.focusManager.popFocus(this.keyProperty);
    this.elementRef.nativeElement.removeEventListener("keydown", this.onkeydow, true);
  }
}
